import Sudoku from './engine/Sudoku';

const useSudoku = () => {
  return Sudoku();
};

export default useSudoku;
